export enum PowerState {
    OFF="off",
    ON="on",
    IDLE="idle"
}